import { usePageContext } from "vike-react/usePageContext";

import { type AjaxError } from "utils/http";

/**
 * Returns the error captured by Vike for the current render, if any. Page
 * components also surface their own fetch errors via react-query `isError`
 * checks; this exposes any error placed on `pageContext` for error UIs.
 */
export const useRouteError = (): AjaxError => {
  const pageContext = usePageContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const err = (pageContext as any).error ?? (pageContext as any).abortReason;
  return (err ?? {}) as AjaxError;
};
